import { useTranslation } from 'react-i18next';

import type { ModuleMessage } from '../helpers/module-messages';

import { Ssm5PanelMessage } from './ssm5-panel-message';

/** Props for {@link Ssm5ModuleMessage}. */
export type Ssm5ModuleMessageProps = {
    /** The message to show. */
    message: ModuleMessage;
};

/**
 * A message of the module panel, translated and drawn as the panel messages are.
 *
 * @param props - {@link Ssm5ModuleMessageProps}
 * @returns the message
 */
export function Ssm5ModuleMessage({ message }: Ssm5ModuleMessageProps) {
    const { t } = useTranslation();

    return (
        <Ssm5PanelMessage
            description={t(message.description)}
            icon={message.icon}
            textWidth={message.textWidth}
            title={t(message.title)}
        />
    );
}
